import { requiredInputRule } from "@erp/shared/utils/form/rules";
import { MEMBER_TYPE } from "@erp/shared/components/ui/Dialog/MemberSearchDialog/member.types";
export var ORDER_BASIC_INFO;
(function (ORDER_BASIC_INFO) {
    ORDER_BASIC_INFO["\uB0A9\uAE30\uC77C"] = "dueDate";
    ORDER_BASIC_INFO["\uC218\uC2E0\uC5C5\uCCB4"] = "companyName";
    ORDER_BASIC_INFO["\uB300\uD45C\uC790"] = "companyManager";
    ORDER_BASIC_INFO["\uB4F1\uB85D\uBC88\uD638"] = "companyRegistrationNumber";
    ORDER_BASIC_INFO["\uC8FC\uC18C"] = "companyAddress";
    ORDER_BASIC_INFO["\uC804\uD654"] = "companyPhone";
    ORDER_BASIC_INFO["\uD329\uC2A4"] = "companyFax";
    ORDER_BASIC_INFO["\uACB0\uC81C\uC870\uAC74"] = "paymentTerms";
    ORDER_BASIC_INFO["\uACC4\uC88C\uC815\uBCF4"] = "accountNumber";
    ORDER_BASIC_INFO["\uBC1C\uC8FC\uD655\uC778\uC11C"] = "orderConfirmationFile";
    ORDER_BASIC_INFO["\uBC1C\uC8FC\uCC98\uC0AC\uC5C5\uC790\uB4F1\uB85D\uC99D"] = "businessRegistrationFile";
    ORDER_BASIC_INFO["\uBC1C\uC8FC\uCC98\uD1B5\uC7A5\uC0AC\uBCF8"] = "bankbookFile";
})(ORDER_BASIC_INFO || (ORDER_BASIC_INFO = {}));
export const orderMemberInfo = [
    {
        type: MEMBER_TYPE.확인,
        givenName: "",
        id: null,
        userName: "",
        email: "",
    },
    {
        type: MEMBER_TYPE.승인,
        givenName: "",
        id: null,
        userName: "",
        email: "",
    },
    {
        type: MEMBER_TYPE.구매담당자,
        givenName: "",
        id: null,
        userName: "",
        email: "",
    },
];
export const orderRequestInfoInputs = [
    {
        label: "납기일",
        column_name: ORDER_BASIC_INFO.납기일,
        type: "dateSingle",
        menu: "",
        col: "12",
        sm: "4",
        lg: "4",
        value: "",
        rules: [requiredInputRule],
    },
    {
        label: "대표자",
        column_name: ORDER_BASIC_INFO.대표자,
        col: "12",
        sm: "4",
        lg: "4",
        value: "",
        rules: [requiredInputRule],
    },
    {
        label: "등록번호",
        column_name: ORDER_BASIC_INFO.등록번호,
        col: "12",
        sm: "4",
        lg: "4",
        value: "",
        rules: [requiredInputRule],
    },
    {
        label: "주소",
        column_name: ORDER_BASIC_INFO.주소,
        col: "12",
        sm: "4",
        lg: "8",
        value: "",
        rules: [requiredInputRule],
    },
    {
        label: "전화",
        column_name: ORDER_BASIC_INFO.전화,
        col: "12",
        sm: "4",
        lg: "4",
        value: "",
        rules: [requiredInputRule],
    },
    {
        label: "팩스",
        column_name: ORDER_BASIC_INFO.팩스,
        col: "12",
        sm: "4",
        lg: "4",
        value: "",
        rules: [requiredInputRule],
    },
    {
        label: "결제조건",
        column_name: ORDER_BASIC_INFO.결제조건,
        col: "12",
        sm: "4",
        lg: "4",
        value: "",
        rules: [requiredInputRule],
    },
    {
        label: "계좌정보",
        column_name: ORDER_BASIC_INFO.계좌정보,
        col: "12",
        sm: "4",
        lg: "4",
        value: "",
        rules: [requiredInputRule],
    },
    {
        label: "발주확인서",
        column_name: ORDER_BASIC_INFO.발주확인서,
        type: "file",
        col: "12",
        sm: "4",
        lg: "4",
        icon: "",
        appendIcon: "mdi-paperclip",
        smallChips: true,
        accept: ".pdf,.jpg,.jpeg,.png,.webp",
        value: null,
    },
    {
        label: "발주처사업자등록증",
        column_name: ORDER_BASIC_INFO.발주처사업자등록증,
        type: "file",
        col: "12",
        sm: "4",
        lg: "4",
        icon: "",
        appendIcon: "mdi-paperclip",
        smallChips: true,
        accept: ".pdf,.jpg,.jpeg,.png,.webp",
        value: null,
    },
    {
        label: "발주처통장사본",
        column_name: ORDER_BASIC_INFO.발주처통장사본,
        type: "file",
        col: "12",
        sm: "4",
        lg: "4",
        icon: "",
        appendIcon: "mdi-paperclip",
        smallChips: true,
        accept: ".pdf,.jpg,.jpeg,.png,.webp",
        value: null,
    },
];
